import { useEffect, useState } from 'react';
import { ArrowRight, Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { BrandLogo } from './BrandLogo';
import { LanguageSelector } from './LanguageSelector';

export function LandingNav({ onLogin }: { onLogin: (mode: 'login' | 'signup') => void }) {
    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);
    const links = [
        ['how-it-works', t('nav.howItWorks')],
        ['sample-report', t('nav.sampleReport')],
        ['faq', t('nav.faq')],
    ];

    useEffect(() => {
        if (!menuOpen) return;
        const closeOnEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setMenuOpen(false);
                document.getElementById('landing-menu-toggle')?.focus();
            }
        };
        document.addEventListener('keydown', closeOnEscape);
        return () => document.removeEventListener('keydown', closeOnEscape);
    }, [menuOpen]);

    const openAuth = (mode: 'login' | 'signup') => {
        setMenuOpen(false);
        onLogin(mode);
    };

    return (
        <header className="landing-nav">
            <a className="landing-skip" href="#landing-content">{t('nav.skip')}</a>
            <nav className="landing-container landing-nav-inner" aria-label={t('nav.main')}>
                <BrandLogo />
                <div className="landing-desktop-links">
                    {links.map(([id, label]) => <a key={id} href={`#${id}`}>{label}</a>)}
                </div>
                <div className="landing-nav-actions">
                    <div className="landing-desktop-language"><LanguageSelector /></div>
                    <button className="landing-login" onClick={() => openAuth('login')}>{t('nav.login')}</button>
                    <button className="landing-button landing-button-small" onClick={() => openAuth('signup')}>
                        {t('nav.startFree')}<ArrowRight size={15} aria-hidden="true" />
                    </button>
                    <button id="landing-menu-toggle" className="landing-menu-toggle" aria-label={t(menuOpen ? 'nav.closeMenu' : 'nav.openMenu')} aria-expanded={menuOpen} aria-controls="landing-mobile-menu" onClick={() => setMenuOpen(!menuOpen)}>
                        {menuOpen ? <X size={23} /> : <Menu size={23} />}
                    </button>
                </div>
            </nav>
            {menuOpen && <div id="landing-mobile-menu" className="landing-mobile-menu">
                {links.map(([id, label]) => <a key={id} href={`#${id}`} onClick={() => setMenuOpen(false)}>{label}</a>)}
                <div className="landing-mobile-menu-bottom">
                    <LanguageSelector />
                    <button className="landing-login" onClick={() => openAuth('login')}>{t('nav.login')}</button>
                </div>
            </div>}
        </header>
    );
}
